module.exports = {
      id: "radio-checked-icon-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#radio-checked-icon",
      toString: function () {
        return this.url;
      }
    }